import { MenuItem } from "../../Types/Layout/Sidebar";

/**
 * Menú lateral simplificado para el SISTEMA DE ADMINISTRACIÓN BACKOFFICE WEB
 * Basado en los requerimientos del documento "Requerimientos Acordados.pdf"
 * 
 * NOTA: Este menú es SOLO para el backoffice web de administración,
 * NO incluye funcionalidades de la app móvil ni página web pública.
 */
export const BusinessMenuList: MenuItem[] = [
  {
    title: "Principal",
    lanClass: "lan-1",
    Items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "home",
        type: "link",
        path: `${process.env.PUBLIC_URL}/dashboard/default`,
        lanClass: "lan-4"
      },
    ],
  },
  {
    title: "Módulos",
    lanClass: "lan-8",
    Items: [
      {
        title: "Consultas Legales",
        id: 2,
        icon: "file-text",
        type: "sub",
        active: false,
        children: [
          { 
            path: `${process.env.PUBLIC_URL}/appointments/list`, 
            type: "link", 
            title: "Gestionar",
            lanClass: "lan-4"
          },
        ],
      },
      {
        title: "Seguimiento de Casos",
        id: 3,
        icon: "clipboard",
        type: "link",
        path: `${process.env.PUBLIC_URL}/case-follow-up`,
        lanClass: "lan-4",
        requiredRole: ["admin", "Admin", "Administrador", "lawyer", "Lawyer", "Abogado"]
      },
      {
        title: "Herramientas & Servicios",
        id: 4,
        icon: "tool",
        type: "sub",
        active: false,
        children: [
          {
            title: "Biblioteca de Recursos",
            id: 41,
            icon: "book",
            type: "sub",
            active: false,
            children: [
              { 
                path: "#", 
                type: "link", 
                title: "Artículos",
                lanClass: "lan-4"
              },
              { 
                path: "#", 
                type: "link", 
                title: "Guías",
                lanClass: "lan-5"
              },
              { 
                path: "#", 
                type: "link", 
                title: "Preguntas Frecuentes",
                lanClass: "lan-6"
              },
              { 
                path: "#", 
                type: "link", 
                title: "Gestión de Recursos",
                requiredRole: ["admin", "Admin", "Administrador"],
                lanClass: "lan-7"
              },
            ],
          },
          {
            title: "Preparación de Documentos",
            id: 42,
            icon: "file-check",
            type: "sub",
            active: false,
            children: [
              { 
                path: "#", 
                type: "link", 
                title: "Formularios",
                lanClass: "lan-4"
              },
              { 
                path: "#", 
                type: "link", 
                title: "Documentos Enviados",
                lanClass: "lan-5"
              },
              { 
                path: "#", 
                type: "link", 
                title: "Revisión de Documentos",
                requiredRole: ["admin", "Admin", "Administrador", "lawyer", "Lawyer", "Abogado"],
                lanClass: "lan-6"
              },
            ],
          },
        ],
      },
      {
        title: "Foro Comunitario",
        id: 6,
        icon: "users",
        type: "sub",
        active: false,
        children: [
          { 
            path: "#", 
            type: "link", 
            title: "Foro",
            lanClass: "lan-4"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Moderación",
            requiredRole: ["admin", "Admin", "Administrador", "moderator", "Moderator"],
            lanClass: "lan-5"
          },
        ],
      },
      {
        title: "Noticias & Información",
        id: 7,
        icon: "rss",
        type: "sub",
        active: false,
        children: [
          { 
            path: "#", 
            type: "link", 
            title: "Noticias",
            lanClass: "lan-4"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Podcasts",
            lanClass: "lan-5"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Gestión de Contenido",
            requiredRole: ["admin", "Admin", "Administrador"],
            lanClass: "lan-6"
          },
        ],
      },
    ],
  },
  {
    title: "Administración",
    lanClass: "lan-9",
    Items: [
      {
        title: "Users",
        icon: "users",
        type: "sub",
        active: false,
        lanClass: "lan-7",
        children: [
          { 
            path: `${process.env.PUBLIC_URL}/users/userprofile`, 
            type: "link", 
            title: "Mi Perfil",
            lanClass: "lan-4"
          },
          { 
            path: `${process.env.PUBLIC_URL}/users/useredit`, 
            type: "link", 
            title: "Editar Perfil",
            lanClass: "lan-5"
          },
          { 
            path: `${process.env.PUBLIC_URL}/users/management`, 
            type: "link", 
            title: "Gestión de Usuarios", 
            requiredRole: ["admin", "Admin", "Administrador"],
            lanClass: "lan-6"
          },
        ],
      },
      {
        title: "Roles y Permisos",
        icon: "shield",
        type: "sub",
        active: false,
        requiredRole: ["admin", "Admin", "Administrador"],
        children: [
          { 
            path: `${process.env.PUBLIC_URL}/roles/management`, 
            type: "link", 
            title: "Gestión de Roles",
            lanClass: "lan-4"
          },
          { 
            path: `${process.env.PUBLIC_URL}/permissions/management`, 
            type: "link", 
            title: "Gestión de Permisos",
            lanClass: "lan-5"
          },
        ],
      },
      {
        title: "Países",
        icon: "map",
        type: "sub",
        active: false,
        requiredRole: ["admin", "Admin", "Administrador"],
        children: [
          { 
            path: `${process.env.PUBLIC_URL}/countries/management`, 
            type: "link", 
            title: "Gestión de Países",
            lanClass: "lan-4"
          },
        ],
      },
      {
        title: "Versiones APK",
        icon: "smartphone",
        type: "sub",
        active: false,
        requiredRole: ["admin", "Admin", "Administrador"],
        children: [
          { 
            path: `${process.env.PUBLIC_URL}/app-versions/management`, 
            type: "link", 
            title: "Gestión de Versiones APK",
            lanClass: "lan-4"
          },
        ],
      },
      {
        title: "Historial de Acceso",
        icon: "clock",
        type: "link",
        path: `${process.env.PUBLIC_URL}/access-history`,
        active: false,
        requiredRole: ["admin", "Admin", "Administrador"],
        lanClass: "lan-7"
      },
      {
        title: "Pagos",
        icon: "dollar-sign",
        type: "sub",
        active: false,
        children: [
          { 
            path: "#", 
            type: "link", 
            title: "Mis Pagos",
            lanClass: "lan-4"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Historial de Pagos",
            lanClass: "lan-5"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Gestión de Pagos",
            requiredRole: ["admin", "Admin", "Administrador"],
            lanClass: "lan-6"
          },
        ],
      },
      {
        title: "Notificaciones",
        icon: "bell",
        type: "link",
        path: `${process.env.PUBLIC_URL}/notifications`,
        lanClass: "lan-4"
      },
      {
        title: "Reportes",
        icon: "bar-chart",
        type: "sub",
        active: false,
        requiredRole: ["admin", "Admin", "Administrador"],
        children: [
          { 
            path: "#", 
            type: "link", 
            title: "Reporte de Consultas",
            lanClass: "lan-4"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Reporte de Documentos",
            lanClass: "lan-5"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Reporte de Casos",
            lanClass: "lan-6"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Analítica General",
            lanClass: "lan-7"
          },
        ],
      },
      {
        title: "Configuración",
        icon: "settings",
        type: "sub",
        active: false,
        requiredRole: ["admin", "Admin", "Administrador"],
        children: [
          { 
            path: "#", 
            type: "link", 
            title: "Configuración General",
            lanClass: "lan-4"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Políticas y Privacidad",
            lanClass: "lan-5"
          },
          { 
            path: "#", 
            type: "link", 
            title: "Actualizaciones de App",
            lanClass: "lan-6"
          },
        ],
      },
    ],
  },
];

